export default {
  //
}



// WEBPACK FOOTER //
// ./src/store/modules/user/userGetters.js